import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

/** One transaction row of the E-D's own account feed (PRD §3.7). */
export interface EdTransaction {
  dateTime: string | null;
  reference: string | null;
  counterparty: string | null;
  amountEur: number;
  status: string;
  statusBadge: string;
}

/** The calling E-D's transactions view (PRD §3.7). */
export interface EdTransactionsView {
  rows: EdTransaction[];
  totalPurchasesEur: number;
  transactionCount: number;
  avgTransactionEur: number;
  dataAvailable: boolean;
}

/**
 * DI token for the E-D Transactions API (PRD §3.7, EM-837). Bound to `EdTransactionsRestService`.
 * E-D-scoped server-side (Rule 22). REST-only (Rules 07/10).
 */
export interface EdTransactionsApi {
  /** GET /services/embedded/api/v1/ed/transactions?sme={id} */
  getTransactions(smeId?: number | null): Observable<EdTransactionsView>;
  /** GET /services/embedded/api/v1/ed/transactions/export?sme={id} — returns a CSV Blob */
  exportTransactions(smeId?: number | null): Observable<Blob>;
}

export const ED_TRANSACTIONS = new InjectionToken<EdTransactionsApi>('ED_TRANSACTIONS');
